import { css } from "@emotion/core";
import { FONTS } from "shared/styles/base";

export const defaultStyles = css`
    .dropdown {
        display: flex;
        background-color: #fff;
        align-items: center;
        justify-content: start;
        width: 100%;
        height: 39.1px;
        border: 1px solid #9b9b9b;
        position: relative;
        font-size: 14px;
        color: #393939;
        font-family: ${FONTS.CERA};
        cursor: pointer;

        :after {
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            right: 10px;
            top: 45%;
            border-width: 6px;
            border-style: solid;
            border-color: #d8d8d8 transparent transparent transparent;
        }

        .dropdown__selected {
            width: 100%;
            height: 100%;
            padding-left: 15px;
            display: flex;
            align-items: center;
            outline: none;
        }

        .dropdown__list {
            padding: 0;
            z-index: 1;
            transform: scale(1, 0);
            transform-origin: 0 0;
            transition: transform ease 250ms;
            margin: 0;
            position: absolute;
            width: 100%;
            left: 0;
            top: 40px;
            overflow-y: auto;
            height: 120px;
            background: #fff;
            border: 1px solid #9b9b9b;
            list-style: none;
        }

        &.show {
            .dropdown__list {
                transform: scale(1, 1);
            }
        }

        .dropdown__item {
            cursor: pointer;
            padding: 5px 10px;
            outline: none;
        }
    }
`;
